export enum ContactColumnKeys {
  ICON = 'icon',
  IDENTIFIER = 'identifier',
  NAME = 'name',
  TYPE = 'type',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
  ADDRESS = 'address',
  ORGANISATION = 'organisationName',
  PERSON = 'contactPerson',
  STATUS = 'status',
  DETAILS = 'openDetails',
  CONTACT_NONE = 'contactNone',
}
